import React from 'react'

const NotFound: React.FC = () => <div>Not found</div>

export default NotFound
